import Api from './Api'
import { errorHandler } from '../../utils'
import {
  AddManualSubscriptionInterface,
  AddManualSubscriptionUserInterface,
  BuySubscriptionByPharmacyInterface,
  BuySubscriptionInterface,
  BuySubscriptionUserInterface,
  SubscriptionInterface,
  SubscriptionUserInterface,
} from 'interfaces/AccountingInterface'
import axios from 'axios'
import { DataTableColumns } from 'interfaces'

class SubscriptionUser extends Api {
  readonly urls = {
    hasUserSubscribe: '/SubscriptionUser/HasUserSubscribe',
    getSubscriptionsType: '/SubscriptionTypeUser/AllActiveSubscriptionTypeUser',
    getBankGateways: 'https://api.daroog.net/payment/GetBankGetwayes',
    buySubscriptions: '/SubscriptionUser/Buy',
    getSubscriptions: '/SubscriptionUser/GetUserSubscribes',
    all: '/SubscriptionTypeUser/AllSubscriptionTypeUser',
    save: '/SubscriptionTypeUser/Save',
    remove: '/SubscriptionTypeUser/Remove/',
    getAllSubscribes: '/SubscriptionUser/GetAllSubscribes',
    addManual: '/SubscriptionUser/AddManual',
    buyByPharmacy: '/SubscriptionUser/BuyByPharmacy',
    checkPharmacyCode: '/SubscriptionUser/CheckPharmacyCode?code=',
  }

  hasUserSubscribe = async (): Promise<any> => {
    try {
      const result = await this.postJsonData(this.urls.hasUserSubscribe)
      localStorage.setItem('hasUserSubscribe', result.data.data.hasSubscribe)
      if (result.data.data.expireDay != undefined) {
        localStorage.setItem(
          'SubscriptionUserExpireDays',
          result.data.data.expireDay,
        )
      } else {
        localStorage.setItem('SubscriptionUserExpireDays', '0')
      }
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  getSubcriptionsType = async (): Promise<any> => {
    try {
      const result = await this.postData(this.urls.getSubscriptionsType)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  checkPharmacyCode = async (code: string): Promise<any> => {
    try {
      const result = await this.postData(this.urls.checkPharmacyCode + code )
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  getBankGatewayes = async (): Promise<any> => {
    try {
      const result = await axios.post(this.urls.getBankGateways)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  buySubscriptions = async (
    data: BuySubscriptionUserInterface,
  ): Promise<any> => {
    try {
      const result = await this.postJsonData(this.urls.buySubscriptions, data)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }
  buyByPharmacy = async (
    data: BuySubscriptionByPharmacyInterface,
  ): Promise<any> => {
    try {
      const result = await this.postJsonData(this.urls.buyByPharmacy, data)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  getSubcriptions = async (
    skip: number = 0,
    top: number = 10,
    searchableColumns: DataTableColumns[] = [],
    searchText: string = '',
  ): Promise<any> => {
    try {
      let url =
        this.urls.getSubscriptions +
        `?$top=${top}&$skip=${skip * top}&$orderby=id desc`

      const result = await this.postData(url)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  save = async (data: SubscriptionUserInterface): Promise<any> => {
    try {
      const result = await this.postJsonData(this.urls.save, data)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  addManual = async (
    data: AddManualSubscriptionUserInterface,
  ): Promise<any> => {
    try {
      const url =
        this.urls.addManual +
        `?userID=${data.userID}&SubscriptionUserTypeId=${data.subscriptionTypeId}&amount=${data.amount}
        &title=${data.title}`
      const result = await this.postData(url)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  all = async (skip: number = 0, top: number = 10): Promise<any> => {
    try {
      const result = await this.postJsonData(
        `${this.urls.all}?$top=${top}&$skip=${skip * top}&$orderby=id desc`,
      )
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  remove = async (id: number | string): Promise<any> => {
    try {
      const result = await this.postJsonData(`${this.urls.remove}${id}`)
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }

  getAllSubscribes = async (
    skip: number = 0,
    top: number = 10,
  ): Promise<any> => {
    try {
      const result = await this.postJsonData(
        `${this.urls.getAllSubscribes}?$top=${top}&$skip=${
          skip * top
        }&$orderby=id desc`,
      )
      return result.data
    } catch (e) {
      errorHandler(e)
      return Promise.reject(e)
    }
  }
}

export default SubscriptionUser
